/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppTransactionsRouteImport } from './routes/_app/transactions'
import { Route as AppOrdersRouteImport } from './routes/_app/orders'
import { Route as AppFinanceRouteImport } from './routes/_app/finance'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppAccessControlRouteImport } from './routes/_app/access-control'
import { Route as AppSplatRouteImport } from './routes/_app/$'
import { Route as AppVenuesIndexRouteImport } from './routes/_app/venues.index'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users.index'
import { Route as AppTicketingIndexRouteImport } from './routes/_app/ticketing.index'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports.index'
import { Route as AppMerchantsIndexRouteImport } from './routes/_app/merchants.index'
import { Route as AppEventsIndexRouteImport } from './routes/_app/events.index'
import { Route as AppEventRequestsIndexRouteImport } from './routes/_app/event-requests.index'
import { Route as AppVenuesVenueIdRouteImport } from './routes/_app/venues.$venueId'
import { Route as AppUsersUserIdRouteImport } from './routes/_app/users.$userId'
import { Route as AppTicketingEventIdRouteImport } from './routes/_app/ticketing.$eventId'
import { Route as AppReportsNewRouteImport } from './routes/_app/reports.new'
import { Route as AppMerchantsMerchantIdRouteImport } from './routes/_app/merchants.$merchantId'
import { Route as AppEventsNewRouteImport } from './routes/_app/events.new'
import { Route as AppEventsEventIdRouteImport } from './routes/_app/events.$eventId'
import { Route as AppEventRequestsEventIdRouteImport } from './routes/_app/event-requests.$eventId'
import { Route as AppMerchantsOnboardingIndexRouteImport } from './routes/_app/merchants.onboarding.index'
import { Route as AppReportsReportIdEditRouteImport } from './routes/_app/reports.$reportId.edit'
import { Route as AppMerchantsOnboardingNewRouteImport } from './routes/_app/merchants.onboarding.new'

const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsRoute = AppTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceRoute = AppFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppAccessControlRoute = AppAccessControlRouteImport.update({
  id: '/access-control',
  path: '/access-control',
  getParentRoute: () => AppRoute,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppRoute,
} as any)
const AppVenuesIndexRoute = AppVenuesIndexRouteImport.update({
  id: '/venues/',
  path: '/venues/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketingIndexRoute = AppTicketingIndexRouteImport.update({
  id: '/ticketing/',
  path: '/ticketing/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppMerchantsIndexRoute = AppMerchantsIndexRouteImport.update({
  id: '/merchants/',
  path: '/merchants/',
  getParentRoute: () => AppRoute,
} as any)
const AppEventsIndexRoute = AppEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => AppRoute,
} as any)
const AppEventRequestsIndexRoute = AppEventRequestsIndexRouteImport.update({
  id: '/event-requests/',
  path: '/event-requests/',
  getParentRoute: () => AppRoute,
} as any)
const AppVenuesVenueIdRoute = AppVenuesVenueIdRouteImport.update({
  id: '/venues/$venueId',
  path: '/venues/$venueId',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersUserIdRoute = AppUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketingEventIdRoute = AppTicketingEventIdRouteImport.update({
  id: '/ticketing/$eventId',
  path: '/ticketing/$eventId',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsNewRoute = AppReportsNewRouteImport.update({
  id: '/reports/new',
  path: '/reports/new',
  getParentRoute: () => AppRoute,
} as any)
const AppMerchantsMerchantIdRoute = AppMerchantsMerchantIdRouteImport.update({
  id: '/merchants/$merchantId',
  path: '/merchants/$merchantId',
  getParentRoute: () => AppRoute,
} as any)
const AppEventsNewRoute = AppEventsNewRouteImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => AppRoute,
} as any)
const AppEventsEventIdRoute = AppEventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => AppRoute,
} as any)
const AppEventRequestsEventIdRoute = AppEventRequestsEventIdRouteImport.update({
  id: '/event-requests/$eventId',
  path: '/event-requests/$eventId',
  getParentRoute: () => AppRoute,
} as any)
const AppMerchantsOnboardingIndexRoute =
  AppMerchantsOnboardingIndexRouteImport.update({
    id: '/merchants/onboarding/',
    path: '/merchants/onboarding/',
    getParentRoute: () => AppRoute,
  } as any)
const AppReportsReportIdEditRoute = AppReportsReportIdEditRouteImport.update({
  id: '/reports/$reportId/edit',
  path: '/reports/$reportId/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppMerchantsOnboardingNewRoute =
  AppMerchantsOnboardingNewRouteImport.update({
    id: '/merchants/onboarding/new',
    path: '/merchants/onboarding/new',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/$': typeof AppSplatRoute
  '/access-control': typeof AppAccessControlRoute
  '/dashboard': typeof AppDashboardRoute
  '/finance': typeof AppFinanceRoute
  '/orders': typeof AppOrdersRoute
  '/transactions': typeof AppTransactionsRoute
  '/event-requests/$eventId': typeof AppEventRequestsEventIdRoute
  '/events/$eventId': typeof AppEventsEventIdRoute
  '/events/new': typeof AppEventsNewRoute
  '/merchants/$merchantId': typeof AppMerchantsMerchantIdRoute
  '/reports/new': typeof AppReportsNewRoute
  '/ticketing/$eventId': typeof AppTicketingEventIdRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/venues/$venueId': typeof AppVenuesVenueIdRoute
  '/event-requests/': typeof AppEventRequestsIndexRoute
  '/events/': typeof AppEventsIndexRoute
  '/merchants/': typeof AppMerchantsIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/ticketing/': typeof AppTicketingIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/venues/': typeof AppVenuesIndexRoute
  '/merchants/onboarding/new': typeof AppMerchantsOnboardingNewRoute
  '/reports/$reportId/edit': typeof AppReportsReportIdEditRoute
  '/merchants/onboarding/': typeof AppMerchantsOnboardingIndexRoute
}
export interface FileRoutesByTo {
  '/accept-invitation': typeof AcceptInvitationRoute
  '/$': typeof AppSplatRoute
  '/access-control': typeof AppAccessControlRoute
  '/dashboard': typeof AppDashboardRoute
  '/finance': typeof AppFinanceRoute
  '/orders': typeof AppOrdersRoute
  '/transactions': typeof AppTransactionsRoute
  '/': typeof AppIndexRoute
  '/event-requests/$eventId': typeof AppEventRequestsEventIdRoute
  '/events/$eventId': typeof AppEventsEventIdRoute
  '/events/new': typeof AppEventsNewRoute
  '/merchants/$merchantId': typeof AppMerchantsMerchantIdRoute
  '/reports/new': typeof AppReportsNewRoute
  '/ticketing/$eventId': typeof AppTicketingEventIdRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/venues/$venueId': typeof AppVenuesVenueIdRoute
  '/event-requests': typeof AppEventRequestsIndexRoute
  '/events': typeof AppEventsIndexRoute
  '/merchants': typeof AppMerchantsIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/ticketing': typeof AppTicketingIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/venues': typeof AppVenuesIndexRoute
  '/merchants/onboarding/new': typeof AppMerchantsOnboardingNewRoute
  '/reports/$reportId/edit': typeof AppReportsReportIdEditRoute
  '/merchants/onboarding': typeof AppMerchantsOnboardingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/_app/$': typeof AppSplatRoute
  '/_app/access-control': typeof AppAccessControlRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/finance': typeof AppFinanceRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/transactions': typeof AppTransactionsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/event-requests/$eventId': typeof AppEventRequestsEventIdRoute
  '/_app/events/$eventId': typeof AppEventsEventIdRoute
  '/_app/events/new': typeof AppEventsNewRoute
  '/_app/merchants/$merchantId': typeof AppMerchantsMerchantIdRoute
  '/_app/reports/new': typeof AppReportsNewRoute
  '/_app/ticketing/$eventId': typeof AppTicketingEventIdRoute
  '/_app/users/$userId': typeof AppUsersUserIdRoute
  '/_app/venues/$venueId': typeof AppVenuesVenueIdRoute
  '/_app/event-requests/': typeof AppEventRequestsIndexRoute
  '/_app/events/': typeof AppEventsIndexRoute
  '/_app/merchants/': typeof AppMerchantsIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/ticketing/': typeof AppTicketingIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/venues/': typeof AppVenuesIndexRoute
  '/_app/merchants/onboarding/new': typeof AppMerchantsOnboardingNewRoute
  '/_app/reports/$reportId/edit': typeof AppReportsReportIdEditRoute
  '/_app/merchants/onboarding/': typeof AppMerchantsOnboardingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/$'
    | '/access-control'
    | '/dashboard'
    | '/finance'
    | '/orders'
    | '/transactions'
    | '/event-requests/$eventId'
    | '/events/$eventId'
    | '/events/new'
    | '/merchants/$merchantId'
    | '/reports/new'
    | '/ticketing/$eventId'
    | '/users/$userId'
    | '/venues/$venueId'
    | '/event-requests/'
    | '/events/'
    | '/merchants/'
    | '/reports/'
    | '/ticketing/'
    | '/users/'
    | '/venues/'
    | '/merchants/onboarding/new'
    | '/reports/$reportId/edit'
    | '/merchants/onboarding/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-invitation'
    | '/$'
    | '/access-control'
    | '/dashboard'
    | '/finance'
    | '/orders'
    | '/transactions'
    | '/'
    | '/event-requests/$eventId'
    | '/events/$eventId'
    | '/events/new'
    | '/merchants/$merchantId'
    | '/reports/new'
    | '/ticketing/$eventId'
    | '/users/$userId'
    | '/venues/$venueId'
    | '/event-requests'
    | '/events'
    | '/merchants'
    | '/reports'
    | '/ticketing'
    | '/users'
    | '/venues'
    | '/merchants/onboarding/new'
    | '/reports/$reportId/edit'
    | '/merchants/onboarding'
  id:
    | '__root__'
    | '/_app'
    | '/accept-invitation'
    | '/_app/$'
    | '/_app/access-control'
    | '/_app/dashboard'
    | '/_app/finance'
    | '/_app/orders'
    | '/_app/transactions'
    | '/_app/'
    | '/_app/event-requests/$eventId'
    | '/_app/events/$eventId'
    | '/_app/events/new'
    | '/_app/merchants/$merchantId'
    | '/_app/reports/new'
    | '/_app/ticketing/$eventId'
    | '/_app/users/$userId'
    | '/_app/venues/$venueId'
    | '/_app/event-requests/'
    | '/_app/events/'
    | '/_app/merchants/'
    | '/_app/reports/'
    | '/_app/ticketing/'
    | '/_app/users/'
    | '/_app/venues/'
    | '/_app/merchants/onboarding/new'
    | '/_app/reports/$reportId/edit'
    | '/_app/merchants/onboarding/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transactions': {
      id: '/_app/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AppTransactionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance': {
      id: '/_app/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AppFinanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/access-control': {
      id: '/_app/access-control'
      path: '/access-control'
      fullPath: '/access-control'
      preLoaderRoute: typeof AppAccessControlRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$': {
      id: '/_app/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/venues/': {
      id: '/_app/venues/'
      path: '/venues'
      fullPath: '/venues/'
      preLoaderRoute: typeof AppVenuesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ticketing/': {
      id: '/_app/ticketing/'
      path: '/ticketing'
      fullPath: '/ticketing/'
      preLoaderRoute: typeof AppTicketingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/merchants/': {
      id: '/_app/merchants/'
      path: '/merchants'
      fullPath: '/merchants/'
      preLoaderRoute: typeof AppMerchantsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events/': {
      id: '/_app/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AppEventsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/event-requests/': {
      id: '/_app/event-requests/'
      path: '/event-requests'
      fullPath: '/event-requests/'
      preLoaderRoute: typeof AppEventRequestsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/venues/$venueId': {
      id: '/_app/venues/$venueId'
      path: '/venues/$venueId'
      fullPath: '/venues/$venueId'
      preLoaderRoute: typeof AppVenuesVenueIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$userId': {
      id: '/_app/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AppUsersUserIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ticketing/$eventId': {
      id: '/_app/ticketing/$eventId'
      path: '/ticketing/$eventId'
      fullPath: '/ticketing/$eventId'
      preLoaderRoute: typeof AppTicketingEventIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/new': {
      id: '/_app/reports/new'
      path: '/reports/new'
      fullPath: '/reports/new'
      preLoaderRoute: typeof AppReportsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/merchants/$merchantId': {
      id: '/_app/merchants/$merchantId'
      path: '/merchants/$merchantId'
      fullPath: '/merchants/$merchantId'
      preLoaderRoute: typeof AppMerchantsMerchantIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events/new': {
      id: '/_app/events/new'
      path: '/events/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof AppEventsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events/$eventId': {
      id: '/_app/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AppEventsEventIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/event-requests/$eventId': {
      id: '/_app/event-requests/$eventId'
      path: '/event-requests/$eventId'
      fullPath: '/event-requests/$eventId'
      preLoaderRoute: typeof AppEventRequestsEventIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/merchants/onboarding/': {
      id: '/_app/merchants/onboarding/'
      path: '/merchants/onboarding'
      fullPath: '/merchants/onboarding/'
      preLoaderRoute: typeof AppMerchantsOnboardingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/$reportId/edit': {
      id: '/_app/reports/$reportId/edit'
      path: '/reports/$reportId/edit'
      fullPath: '/reports/$reportId/edit'
      preLoaderRoute: typeof AppReportsReportIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/merchants/onboarding/new': {
      id: '/_app/merchants/onboarding/new'
      path: '/merchants/onboarding/new'
      fullPath: '/merchants/onboarding/new'
      preLoaderRoute: typeof AppMerchantsOnboardingNewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute
  AppAccessControlRoute: typeof AppAccessControlRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppFinanceRoute: typeof AppFinanceRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppTransactionsRoute: typeof AppTransactionsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppEventRequestsEventIdRoute: typeof AppEventRequestsEventIdRoute
  AppEventsEventIdRoute: typeof AppEventsEventIdRoute
  AppEventsNewRoute: typeof AppEventsNewRoute
  AppMerchantsMerchantIdRoute: typeof AppMerchantsMerchantIdRoute
  AppReportsNewRoute: typeof AppReportsNewRoute
  AppTicketingEventIdRoute: typeof AppTicketingEventIdRoute
  AppUsersUserIdRoute: typeof AppUsersUserIdRoute
  AppVenuesVenueIdRoute: typeof AppVenuesVenueIdRoute
  AppEventRequestsIndexRoute: typeof AppEventRequestsIndexRoute
  AppEventsIndexRoute: typeof AppEventsIndexRoute
  AppMerchantsIndexRoute: typeof AppMerchantsIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppTicketingIndexRoute: typeof AppTicketingIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppVenuesIndexRoute: typeof AppVenuesIndexRoute
  AppMerchantsOnboardingNewRoute: typeof AppMerchantsOnboardingNewRoute
  AppReportsReportIdEditRoute: typeof AppReportsReportIdEditRoute
  AppMerchantsOnboardingIndexRoute: typeof AppMerchantsOnboardingIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
  AppAccessControlRoute: AppAccessControlRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppFinanceRoute: AppFinanceRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppTransactionsRoute: AppTransactionsRoute,
  AppIndexRoute: AppIndexRoute,
  AppEventRequestsEventIdRoute: AppEventRequestsEventIdRoute,
  AppEventsEventIdRoute: AppEventsEventIdRoute,
  AppEventsNewRoute: AppEventsNewRoute,
  AppMerchantsMerchantIdRoute: AppMerchantsMerchantIdRoute,
  AppReportsNewRoute: AppReportsNewRoute,
  AppTicketingEventIdRoute: AppTicketingEventIdRoute,
  AppUsersUserIdRoute: AppUsersUserIdRoute,
  AppVenuesVenueIdRoute: AppVenuesVenueIdRoute,
  AppEventRequestsIndexRoute: AppEventRequestsIndexRoute,
  AppEventsIndexRoute: AppEventsIndexRoute,
  AppMerchantsIndexRoute: AppMerchantsIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppTicketingIndexRoute: AppTicketingIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppVenuesIndexRoute: AppVenuesIndexRoute,
  AppMerchantsOnboardingNewRoute: AppMerchantsOnboardingNewRoute,
  AppReportsReportIdEditRoute: AppReportsReportIdEditRoute,
  AppMerchantsOnboardingIndexRoute: AppMerchantsOnboardingIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
